export default __webpack_public_path__ + "static/client2-d5e93df985e31a3372d2c14cb6f58a24.png";